import { PayloadAction } from '@reduxjs/toolkit';
import { WritableDraft } from 'immer';

import { QuoteBuilderStateType } from '../../types/state';
import { QuoteBuilderDialogType } from '../../types/state/internal';

export function dialogOpened(
  state: WritableDraft<QuoteBuilderStateType>,
  action: PayloadAction<QuoteBuilderDialogType>,
) {
  state.dialog = action.payload;
}
